import styled from 'styled-components';

const ModalHeader = styled.div`
  margin-bottom: 16px;
`;

const ModalSection = styled.div`
  margin-bottom: 12px;
`;

const WarningText = styled.strong`
  color: red;
`;

const ClientName = styled.div`
  padding: 8px;
  background: #f5f5f5;
  margin-top: 4px;
  font-family: monospace;
`;
const ClientKey = styled.div`
  padding: 8px;
  background: #f5f5f5;
  margin-top: 4px;
  font-family: monospace;
  word-break: break-all;
`;

export { ModalHeader, ModalSection, WarningText, ClientName, ClientKey };
